export const graphExtrusionFormConfig = [
  {
    id: 1,
    graph_label: "On / Off /Idle",
    fields: [
      {
        id: 10,
        label: "On Time",
        required: true,
        meta: [],
      },
      {
        id: 11,
        label: "Off Time",
        required: true,
        meta: [],
      },
      {
        id: 12,
        label: "Idle Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    graph_label: "Length",
    id: 2,
    fields: [
      {
        id: 13,
        label: "length",
        required: true,
        meta: [],
      },
    ],
  },
  {
    graph_label: "Speed",
    id: 3,
    fields: [
      {
        id: 14,
        label: "Speed",
        required: true,
        meta: [],
      },
    ],
  },
  {
    id: 4,
    graph_label: "Power consumption",
    fields: [
      {
        id: 15,
        label: "Kwh",
        required: false,
        meta: [],
      },
    ],
  },
  {
    id: 5,
    graph_label: "Status",
    fields: [
      {
        id: 16,
        label: "Machine Status",
        required: false,
        meta: [],
      },
      {
        id: 17,
        label: "Supply Status",
        required: false,
        meta: [],
      },
    ],
  },
];
